import './HeaderCreateButton.scss';
import { ReactComponent as PlusIcon } from 'images/icons/Plus.svg';
import { Button } from '@trackman/web-shared-components';
import { ButtonIntent } from '@trackman/web-shared-components/components/types';

type Props = {
  buttonTitle: string;
  intent?: ButtonIntent;
  onClick?: () => void;
};

export const HeaderCreateButton = ({ buttonTitle, intent = 'primary', onClick }: Props) => {
  return <Button startIcon={<PlusIcon />} label={buttonTitle} intent={intent} className='header-create-button' onClick={onClick} />;
};

export default HeaderCreateButton;
